/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Edition_LifetimeInputs */



/**
* | output |
* | --- |
* | "Lifetime licence" |
*
* @param {License_Edition_LifetimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_edition_lifetime = /** @type {((inputs?: License_Edition_LifetimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Edition_LifetimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Licence à vie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lebenslange Lizenz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Licenza a vita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бессрочная лицензия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Licencia vitalicia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("永久许可证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("永続ライセンス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइफ़टाइम लाइसेंस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Licença vitalícia")
	return /** @type {LocalizedString} */ ("Lifetime licence")
});